import React, {
  FC, ReactNode, useState, memo
} from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './oldPanelComponent.module.css';

type PropsType = {
  children: ReactNode;
  isSticky?: boolean;
  isDoublePage?: boolean;
};

export const PanelSubSectionComponent: FC<PropsType> = ({ children }) => (
    <div className={styles.subSectionContainer}>
        {children}
    </div>
);

export const PanelSectionComponent: FC<PropsType> = ({ children, isSticky, isDoublePage }) => (
    <div className={classNames(styles.sectionContainer, { [styles.isSticky]: isSticky, [styles.isDoublePage]: isDoublePage })}>
        {children}
    </div>
);

const OldPanelComponent: FC<PropsType> = ({ children }) => {
  const { t } = useTranslation();
  const [isClose, setClose] = useState(true);

  const onToggleClose = () => setClose(!isClose);

  return (
        <div className={classNames(styles.container, { [styles.isClose]: isClose })}>
            <div className={styles.visibleButton} onClick={onToggleClose}>{isClose ? t('panel.show') : t('panel.hide')} {t('panel.settings')}</div>
            <div className={styles.wrapper}>{children}</div>
        </div>
  );
};

export default memo(OldPanelComponent);
